import { SettingsBackupRestore } from "@mui/icons-material";
import { IconButton, type IconButtonProps, Tooltip } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";
import { useIntl } from "react-intl";

export const ResetButton: FC<PropsWithChildren<IconButtonProps>> = (props) => {
    const intl = useIntl();
    return (
        <IconButton {...props} size="large">
            <Tooltip title={intl.formatMessage({ id: "reviermanager.filter.rest", defaultMessage: "Filter zurücksetzen" })}>
                <SettingsBackupRestore fontSize="inherit" />
            </Tooltip>
        </IconButton>
    );
};
